import { render, staticRenderFns } from "./definition-de-notoriete-de-marque.vue?vue&type=template&id=0b0fb055&"
import script from "./definition-de-notoriete-de-marque.vue?vue&type=script&lang=js&"
export * from "./definition-de-notoriete-de-marque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports